import { Spin } from "antd";
import React from "react";

const LoadingComponent = () => {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ height: "100vh" }}
    >
      <Spin />
    </div>
  );
};

export default LoadingComponent